<template>
    <div class="billing-center-box">
        <van-nav-bar title="花惠卡折扣" />
        <van-tabs @click="onClick" color="#fe7b43">
            <van-tab name="0" title="全部"></van-tab>
            <van-tab name="2" title="生效中"></van-tab>
            <van-tab name="1" title="审核中"></van-tab>
            <van-tab name="5" title="不通过"></van-tab>
            <van-tab name="4" title="已失效"></van-tab>
        </van-tabs>
        <div class="hhk-content">
            <div class="hhk-item df" v-for="(item, index) in hhkList" :key="index" @click="onGoEditPage(item)">
                <div class="left">
                    <div class="hhk-item-name">{{ item.discountTitle }}</div>
                    <div>对外折扣：{{ item.externalDiscount }} 折</div>
                    <div>花惠卡折扣：{{ item.internalDiscount }} 折</div>
                </div>
                <div class="right">{{ item.audit | fhhk }}</div>
            </div>
        </div>
        <div class="hhk-btn-box">
            <van-button type="default" color="#FF6633" block :to="{ path: '/add-or-edit-hhk', query: { isAdd: true } }">
                添加花惠卡折扣
            </van-button>
        </div>
    </div>
</template>

<script>
import { getMallOrgDiscount } from '../api/index';
import { Toast } from 'vant';
export default {
    data() {
        return {
            hhkList: [],
            paramas: {
                phone: '',
                audit: '0'
            }
        };
    },
    mounted() {
        this.paramas.phone = this.$globalData.phone1;
        this.getMallOrgDiscount();
    },
    methods: {
        getMallOrgDiscount() {
            getMallOrgDiscount(this.paramas).then(res => {
                this.hhkList = res.data;
            });
        },
        onClick(e) {
            this.paramas.audit = e;
            this.getMallOrgDiscount();
        },
        // 前往编辑页
        onGoEditPage(item) {
            console.log(item);
            if (item.audit === 1) return Toast('花惠卡正在审核中');
            this.$router.push({ path: '/add-or-edit-hhk', query: { isAdd: false, item: JSON.stringify(item) } });
        }
    },
    filters: {
        fhhk: function(value) {
            if (value === 1) return '未审核';
            if (value === 2) return '审核通过';
            if (value === 5) return '审核拒绝';
        }
    }
};
</script>

<style scoped lang="scss">
.billing-center-box {
    height: 100vh;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;

    .hhk-content {
        flex: 1;
        border-top: 1px solid #eeeeee;
        overflow: auto;

        .hhk-item {
            padding: 15px 10px;
            font-size: 14px;
            align-items: center;
            border-bottom: 1px solid #eeeeee;
            background-color: #ffffff;

            .left {
                flex: 1;

                .hhk-item-name {
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
        .hhk-item:active {
            background-color: #eeeeee;
        }
    }

    .hhk-btn-box {
        padding: 10px 10px;
        background-color: #ffffff;
        border-top: 1px solid #eeeeee;

        .van-button {
            font-size: 16px;
        }
    }
}
</style>
